
import { defineComponent, onMounted, reactive, ref, computed } from "vue";
import XAtable from "@/components/XATable.vue";
import {
  userQueryPageList,
  sysNovelConfigList,
  userAddAppUser,
  userUpdateAppUser,
  userRecharge,
  userReBack,
  appUserAgentList,
} from "@/api/api";
import XDialog from "@/components/XDialog.vue";
import type { Rule } from "ant-design-vue/es/form";
import { message, type FormInstance } from "ant-design-vue";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { hasPermission } from "@/utils/permission";

type RangeValue = [Dayjs, Dayjs];

interface SearchFormState {
  userId: string;
  name: string;
  mobile: string;
  sysId: string | number;
  //   time: RangeValue;
}

interface FormState {
  name: string;
  mobile: string;
  company: string;
  businessType: number;
  serviceAmount: number | null;
  status: number;
  wallet: string;
  id: string;
  sysId: string | number;
  userType: number;
  remark: string;
  remark2: string;
}
export default {
  components: {
    XAtable,
    XDialog,
  },
  setup() {
    const searchFormState = reactive<SearchFormState>({
      userId: "",
      name: "",
      mobile: "",
      sysId: "",
      //   time: [
      //     dayjs(
      //       new Date(dayjs().year(), dayjs().month(), dayjs().get("date") - 180)
      //     ),
      //     dayjs(),
      //   ],
    });
    const formState = reactive<FormState>({
      name: "",
      mobile: "",
      status: 1,
      wallet: "",
      company: "",
      businessType: 0,
      serviceAmount: null,
      id: "",
      sysId: "",
      userType: 0,
      remark: "",
      remark2: "",
    });
    const isAdd = ref(1);
    const dislogVisible = ref(false);
    const addLoading = ref(false);
    const pageNo = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const appList = ref([]);
    const dateFormat = ref("YYYY-MM-DD");
    const loading = ref(false);

    // 基础列配置
    const baseColumns = [
      {
        title: "ID",
        key: "id",
        dataIndex: "id",
      },
      {
        title: "用户名",
        key: "name",
        dataIndex: "name",
      },
      {
        title: "邮箱",
        key: "mobile",
        dataIndex: "mobile",
      },
      {
        title: "备注",
        key: "remark",
        dataIndex: "remark",
      },
      {
        title: "公司",
        key: "company",
        dataIndex: "company",
      },
      {
        title: "分类",
        key: "businessType",
        dataIndex: "businessType",
        slots: {
          customRender: "businessType",
        },
      },
      {
        title: "服务费",
        key: "serviceAmount",
        dataIndex: "serviceAmount",
        slots: {
          customRender: "serviceAmount",
        },
      },
      {
        title: "公司识别码",
        key: "userNo",
        dataIndex: "userNo",
      },
      {
        title: "余额($)",
        key: "wallet",
        dataIndex: "wallet",
      },
      {
        title: "状态",
        key: "status",
        dataIndex: "status",
        slots: {
          customRender: "status",
        },
      },
      {
        title: "用户类型",
        key: "userType",
        dataIndex: "userType",
        slots: {
          customRender: "userType",
        },
      },
      {
        title: "代理",
        key: "sysName",
        dataIndex: "sysName",
      },
      {
        title: "创建时间",
        key: "createTime",
        dataIndex: "createTime",
        width: 180,
      },
    ];

    // 操作列配置
    const operationColumn = {
      title: "操作",
      key: "control",
      dataIndex: "control",
      slots: {
        customRender: "control",
      },
    };

    // 动态计算是否显示操作列
    const hasAnyOperationPermission = computed(() => {
      // 检查是否有任何操作权限
      return hasPermission("user.list.update");
    });

    // 动态列配置
    const columns = computed(() => {
      const cols = [...baseColumns];
      // 如果有任何操作权限，则显示操作列
      if (hasAnyOperationPermission.value) {
        cols.push(operationColumn);
      }
      return cols;
    });

    const tableData = ref([]);
    const formRef = ref<FormInstance>();
    const topUpDislogVisible = ref(false);
    const topUpLoading = ref(false);
    const reBackDislogVisible = ref(false);
    const reBackLoading = ref(false);
    const reBackFormRef = ref<FormInstance>();
    const currentUserWallet = ref<string | number>(""); // 保存当前用户的余额
    const agentList = ref([]);
    const agentPageNo = ref(1);
    const agentPageSize = ref(10);
    const agentTotal = ref(0);
    const agentLoading = ref(false);
    const agentHasMore = ref(true);
    const searchAgentList = ref([]);
    const searchAgentPageNo = ref(1);
    const searchAgentPageSize = ref(10);
    const searchAgentTotal = ref(0);
    const searchAgentLoading = ref(false);
    const searchAgentHasMore = ref(true);


    const getAgentList = (isLoadMore = false) => {
      if (agentLoading.value) return;

      // 如果不是加载更多，重置页码
      if (!isLoadMore) {
        agentPageNo.value = 1;
        agentHasMore.value = true;
      }

      // 如果没有更多数据，不加载
      if (!agentHasMore.value) return;

      agentLoading.value = true;
      appUserAgentList({
        pageNo: agentPageNo.value,
        pageSize: agentPageSize.value,
      })
        .then((res) => {
          const records = res.data?.records || [];
          const total = res.data?.total || 0;

          if (isLoadMore) {
            // 追加数据
            agentList.value = [...agentList.value, ...records];
          } else {
            // 首次加载或重置
            agentList.value = records;
          }

          agentTotal.value = total;
          agentHasMore.value = agentList.value.length < total;

          // 更新页码，为下次加载做准备
          if (agentHasMore.value) {
            agentPageNo.value += 1;
          }
        })
        .finally(() => {
          agentLoading.value = false;
        });
    };

    const handleAgentScroll = (e: any) => {
      const { target } = e;
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;

      // 滚动到底部时加载更多
      if (
        scrollHeight - scrollTop <= clientHeight + 10 &&
        agentHasMore.value &&
        !agentLoading.value
      ) {
        getAgentList(true);
      }
    };

    // 加载搜索用的代理列表（支持分页）
    const getSearchAgentList = (isLoadMore = false) => {
      if (searchAgentLoading.value) return;

      // 如果不是加载更多，重置页码
      if (!isLoadMore) {
        searchAgentPageNo.value = 1;
        searchAgentHasMore.value = true;
      }

      // 如果没有更多数据，不加载
      if (!searchAgentHasMore.value) return;

      searchAgentLoading.value = true;
      appUserAgentList({
        pageNo: searchAgentPageNo.value,
        pageSize: searchAgentPageSize.value,
      })
        .then((res) => {
          const records = res.data?.records || [];
          const total = res.data?.total || 0;

          if (isLoadMore) {
            // 追加数据
            searchAgentList.value = [...searchAgentList.value, ...records];
          } else {
            // 首次加载或重置
            searchAgentList.value = records;
          }

          searchAgentTotal.value = total;
          searchAgentHasMore.value = searchAgentList.value.length < total;

          // 更新页码，为下次加载做准备
          if (searchAgentHasMore.value) {
            searchAgentPageNo.value += 1;
          }
        })
        .finally(() => {
          searchAgentLoading.value = false;
        });
    };

    // 处理搜索下拉框滚动事件
    const handleSearchAgentScroll = (e: any) => {
      const { target } = e;
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;

      // 滚动到底部时加载更多
      if (
        scrollHeight - scrollTop <= clientHeight + 10 &&
        searchAgentHasMore.value &&
        !searchAgentLoading.value
      ) {
        getSearchAgentList(true);
      }
    };

    const search = () => {
      pageNo.value = 1;
      getData();
    };
    const resetForm = () => {
      searchFormState.userId = "";
      searchFormState.name = "";
      searchFormState.mobile = "";
      searchFormState.sysId = "";
      //   searchFormState.time = [
      //     dayjs(
      //       new Date(dayjs().year(), dayjs().month(), dayjs().get("date") - 180)
      //     ),
      //     dayjs(),
      //   ];
      pageNo.value = 1;
      getData();
    };
    const getAppList = () => {
      loading.value = true;
      sysNovelConfigList({}).then((res) => {
        appList.value = res.data;
        // searchFormState.appId = res.data[0].id;
        getData();
      });
    };
    const getData = () => {
      loading.value = true;
      const uid = String(searchFormState.userId || "").trim();
      var parms: Record<string, unknown> = {
        // beginTime:
        //   dayjs(searchFormState.time[0]).format(dateFormat.value) + " 00:00:00",
        // endTime:
        //   dayjs(searchFormState.time[1]).format(dateFormat.value) + " 00:00:00",
        // id: searchFormState.appId ? searchFormState.appId : null,
        name: searchFormState.name,
        mobile: searchFormState.mobile,
        sysId: searchFormState.sysId || null,
        pageNo: pageNo.value,
        pageSize: pageSize.value,
      };
      if (uid) {
        const n = Number(uid);
        parms.id = Number.isFinite(n) && String(n) === uid ? n : uid;
      }
      userQueryPageList(parms).then((res) => {
        loading.value = false;
        total.value = res.data.total;
        tableData.value = res.data.records;
      });
    };
    const pageNoChange = (val) => {
      pageNo.value = val;
      getData();
    };
    const onShowSizeChange = (current, size) => {
      pageSize.value = size;
      getData();
    };
    const selectChange = () => {
      pageNo.value = 1;
      getData();
    };
    const addClick = () => {
      isAdd.value = 1;
      dislogVisible.value = true;
      formState.name = "";
      formState.mobile = "";
      formState.company = "";
      formState.businessType = 0;
      formState.serviceAmount = null;
      formState.id = "";
      formState.status = 1;
      formState.wallet = "";
      formState.sysId = "";
      formState.userType = 0;
      formState.remark = "";
      formState.remark2 = "";
      // 重置代理列表分页并加载第一页
      agentList.value = [];
      getAgentList(false);
    };
    const editClick = (row: any) => {
      isAdd.value = 0;
      for (const key in formState) {
        formState[key] = row[key];
      }
      // 如果后端没有返回 userType，默认设置为 0（外部）
      if (formState.userType === undefined || formState.userType === null) {
        formState.userType = 0;
      }
      if (formState.businessType === undefined || formState.businessType === null) {
        formState.businessType = 0;
      }
      formState.remark2 = "";
      dislogVisible.value = true;
      // 重置代理列表分页并加载第一页
      agentList.value = [];
      getAgentList(false);
    };
    const confirm = async () => {
      try {
        const values = await formRef.value.validateFields();
        addLoading.value = true;

        if (isAdd.value === 1) {
          formState.id = "";
          const { remark2: _omitRemark2, ...userPayload } = formState;
          userAddAppUser(userPayload).then((res) => {
            addLoading.value = false;
            if (res.code === "200") {
              message.success("添加成功！");
              dislogVisible.value = false;
              getData();
            }
          });
        } else {
          const { remark2: _omitRemark2, ...userPayload } = formState;
          userUpdateAppUser(userPayload).then((res) => {
            addLoading.value = false;
            if (res.code === "200") {
              message.success("编辑成功！");
              dislogVisible.value = false;
              getData();
            }
          });
        }
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };
    const topUptoUser = (row: any) => {
      for (const key in formState) {
        formState[key] = row[key];
      }
      formState.wallet = "";
      formState.remark2 = "";
      topUpDislogVisible.value = true;
    };
    const topUpConfirm = () => {
      try {
        topUpLoading.value = true;
        userRecharge({
          id: formState.id,
          wallet: formState.wallet,
          remark2: formState.remark2,
        }).then((res) => {
          topUpLoading.value = false;
          if (res.code === "200") {
            message.success("充值成功！");
            topUpDislogVisible.value = false;
            getData();
          }
        });
      } catch {}
    };
    const reBackToUser = (row: any) => {
      for (const key in formState) {
        formState[key] = row[key];
      }
      // 保存当前用户的余额
      currentUserWallet.value = row.wallet || "";
      formState.wallet = "";
      formState.remark2 = "";
      reBackDislogVisible.value = true;
    };
    const fillAllAmount = () => {
      // 将余额填充到退款金额输入框
      const wallet = currentUserWallet.value;
      if (wallet) {
        const walletStr = typeof wallet === 'number' ? wallet.toFixed(2) : wallet;
        // 模拟输入事件来触发格式化
        const event = { target: { value: walletStr } };
        limitAmount(event);
      }
    };
    const reBackConfirm = async () => {
      try {
        await reBackFormRef.value?.validateFields();
        reBackLoading.value = true;
        userReBack({
          id: formState.id,
          wallet: formState.wallet,
        }).then((res) => {
          reBackLoading.value = false;
          if (res.code === "200") {
            message.success("退款成功！");
            reBackDislogVisible.value = false;
            getData();
          }
        });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
      }
    };
    const limitAmount = (event: any) => {
      formState.wallet = event.target.value
        .replace(/[^\d.]/g, "")
        // 限制只有一个小数点
        .replace(/^\./g, "")
        .replace(/\.{2,}/g, ".")
        // 限制小数点后只能有两位
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d{2}).*$/, "$1$2.$3");
    };
    
    onMounted(() => {
      getSearchAgentList();
      getData();
    });
    return {
      isAdd,
      formRef,
      dislogVisible,
      addClick,
      confirm,
      topUpConfirm,
      searchFormState,
      formState,
      addLoading,
      columns,
      appList,
      tableData,
      pageNo,
      dateFormat,
      total,
      loading,
      topUpDislogVisible,
      topUpLoading,
      search,
      resetForm,
      pageNoChange,
      onShowSizeChange,
      selectChange,
      editClick,
      topUptoUser,
      limitAmount,
      agentList,
      handleAgentScroll,
      agentLoading,
      searchAgentList,
      handleSearchAgentScroll,
      searchAgentLoading,
      reBackToUser,
      reBackConfirm,
      reBackDislogVisible,
      reBackLoading,
      reBackFormRef,
      fillAllAmount,
    };
  },
};
